import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { find, findIndex, sortBy } from "lodash";
import { RegraFreteService } from "./../../../../services/regra-frete.service";
@Component({
  selector: "mandae-condicao-estados",
  templateUrl: "./estados.component.html",
  styleUrls: ["./estados.component.scss"],
})
export class CondicaoEstadosComponent implements OnInit, OnDestroy {
  public formulario: FormGroup;

  public restricoes: any[] = [];

  public listaEstados = [];

  public estados = [];

  @Output()
  public condicaoResponse = new EventEmitter();

  @Input()
  public set Data(data) {
    if (data) {
      if (data.length) {
        data.map((estado) => {
          const index = findIndex(this.listaEstados, { sigla: estado });
          this.restricoes.push(find(this.estados, { sigla: estado }));

          this.listaEstados.splice(index, 1);
        });
      }
    }
  }

  @Input()
  public label = "Estados";

  @Input()
  public fieldName = "estados";

  constructor(
    private formBuilder: FormBuilder,
    private regraFreteService: RegraFreteService
  ) {
    this.estados = this.regraFreteService.listaEstados();
    this.formulario = this.formBuilder.group({
      estado: ["-", Validators.required],
    });

    this.listaEstados = this.estados;
  }

  public ngOnInit() {
    this.listaEstados = this.estados;
  }

  public ngOnDestroy() {
    this.listaEstados = [];
  }

  public formData(value) {
    return this.formulario.get(value).value;
  }

  public adicionar(): void {
    const estado = this.formulario.get("estado").value;

    if (estado !== "-") {
      this.restricoes.push(find(this.estados, { sigla: estado }));

      this.apagarCampos();

      this.condicaoResponse.emit({
        tipo: this.fieldName,
        valor: this.restricoes.map((restricao) => {
          return restricao.sigla;
        }),
      });

      const index = findIndex(this.listaEstados, { sigla: estado });
      this.listaEstados.splice(index, 1);
    }
  }

  public remover(estado): void {
    const index = findIndex(this.restricoes, {
      sigla: estado.sigla,
    });

    if (index !== -1) {
      this.restricoes.splice(index, 1);

      if (findIndex(this.listaEstados, { sigla: estado.sigla }) === -1) {
        this.listaEstados.push(estado);
        this.listaEstados = sortBy(this.listaEstados, "nome");
      }
    }

    this.condicaoResponse.emit({
      tipo: this.fieldName,
      valor: this.restricoes.map((restricao) => {
        return restricao.sigla;
      }),
    });
  }

  public apagarCampos() {
    this.formulario.get("estado").setValue("-");
    this.formulario.get("estado").markAsUntouched();
  }

  public getNomeEstado(sigla) {
    const estado: any = find(this.estados, { sigla });

    return estado.nome;
  }
}
